<template>
    <figure class="flex flex-col gap-4">
        <div class="flex items-center justify-center gap-[10px]">
            <v-icon icon="user-chat" size="5"></v-icon>
            <div class="text-body-medium-button text-black-78">
                Slika profila
            </div>
        </div>
        <div class="flex flex-col items-center gap-8">
            <figure class="mx-auto flex max-w-[240px] flex-col gap-8">
                <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    name="profilePicture"
                    ref="file"
                    @change="onFileChange"
                    style="display: none"
                />
                <template v-if="profileImg !== 0">
                    <img
                        class="lazy mx-auto h-[240px] w-[240px] rounded-full shadow"
                        :src="profileImg"
                    />
                </template>
                <template v-else>
                    <img
                        class="lazy mx-auto h-[240px] w-[240px] rounded-full shadow"
                        :src="$assetsUrl + '/images/profile_placeholder.png'"
                        alt=""
                    />
                </template>
                <figure class="flex flex-col gap-4">
                    <a class="button h-[48px] px-6" @click="$refs.file.click()">
                        <label class="text-small-text-medium"
                            >Spremenite sliko</label
                        >
                        <v-icon icon="upload" size="4"></v-icon>
                    </a>
                </figure>
                <p
                    class="text-small-text-regular text-salmon"
                    v-if="pictureError"
                    v-text="pictureError"
                ></p>
            </figure>
        </div>
    </figure>
</template>

<script>
export default {
    props: {
        validationErrors: {
            type: Object,
            required: true,
        },
        existingProfilePicture: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            profileImg: "/assets/images/profile.webp",
        };
    },
    computed: {
        pictureError() {
            if (!("profilePicture" in this.validationErrors)) return null;

            return this.validationErrors.profilePicture[0];
        },
    },
    mounted() {
        if (this.existingProfilePicture !== "") {
            this.profileImg = this.existingProfilePicture;
        }
    },
    methods: {
        onFileChange(e) {
            const file = e.target.files[0];
            this.profileImg = URL.createObjectURL(file);
        },
    },
};
</script>
